import "./Hero.scss";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    // Set interval to update the text every 5000 milliseconds
    const intervalId = setInterval(() => {
      setIsVisible((prev) => !prev);
    }, 3500);

    return () => clearInterval(intervalId);
  }, []);
    return (
      <div className="hero">
        <div className="hero__background"></div>
        <div className="hero__content">
          {isVisible && (
            <>
              <h1 className="hero__title hero__title--mobile">
                {t("hero.mottoMobile")}
              </h1>
              <h1 className="hero__title hero__title--desktop">
                {t("hero.motto")}
              </h1>
            </>
          )}

          <>
            <h3 className="hero__title--mobile">
              {t("hero.titleMobile")}
              <br />
              {t("hero.subtitleMobile")}
            </h3>
            <h3 className="hero__title--desktop">
              {t("hero.title")}
              <br />
              {t("hero.subtitle")}
            </h3>
          </>
        </div>
      </div>
    );
}

export default Hero;